import { FilterBase } from './FilterBase';


export class FilterMission extends FilterBase {
        
    public fleetIds:Array<number>
    public gliderIds:Array<number>
    public ensIds:Array<number>
    public hasSetEnsids:boolean
    public alarmIds:Array<string>
    public onGoing:boolean
    public simulated:boolean
    

    constructor({fleetIds = [] as Array<number>,gliderIds = [] as Array<number>, ensIds = [] as Array<number>, alarmIds = [] as Array<string>,onGoing = false,simulated = false,...args} = {}) { 
        super(args)       
        this.hasSetEnsids = false
        this.fleetIds = fleetIds
        this.gliderIds = gliderIds
        this.ensIds = ensIds
        this.onGoing = onGoing
        this.simulated = simulated
        this.alarmIds = alarmIds
    }
}
